<i18n lang="yaml">
en:
  distanceAway: '{distance} {unit} away'
fr:
  distanceAway: 'à {distance} {unit}'
</i18n>

<template>
  <div>
    <NuxtLink :to="getLocalePath({ name: 'rvs-for-sale-keyword-location-place', params: { place: place.route } })">
      <dt class="font-semibold text-gray-900">{{ useFullName ? place.placeName : place.name }}</dt>
      <dd v-if="place.distance" class="text-gray-600">
        {{
          t('distanceAway', {
            distance: Math.round(unit === 'km' ? place.distance : kilometersToMiles(place.distance)),
            unit
          })
        }}
      </dd>
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
import type { Place } from '~/types/api'

withDefaults(
  defineProps<{
    unit: 'km' | 'mi'
    place: Place
    useFullName: boolean
  }>(),
  {
    unit: 'km',
    useFullName: true
  }
)

const { t } = useI18n()
</script>
